'use client';

import React from 'react'

import IconWrapper from '@/components/ui/IconWrapper/IconWrapper';
import useRemValue from '@/hooks/useRemValue';

interface PlayerButtonProps extends React.BaseHTMLAttributes<HTMLElement> {
	children: React.ReactElement<{ color?: string }>;
	size?: 44 | 56 | 68,
	disabled?: boolean,
	onClick?: () => void;
	className?: string;
	absolute?: boolean;
}


const SIZE_TO_PADDING: Record<number, number> = {
	44: 0.75,
	56: 1,
	68: 1.25,
};

const WRAPPER_SIZE_TO_ICON_SIZE: Record<number, number> = {
	44: 1.25,
	56: 1.5,
	68: 1.75,
};



const PlayerButton: React.FC<PlayerButtonProps> = ({
	children,
	size = 56,
	className = "",
	disabled = false,
	onClick = () => { },
	absolute = false,
	style: externalStyle,
	...rest
}) => {
	const rem = useRemValue();

	return (
		<button
			disabled={disabled}
			onClick={onClick}
			{...rest}
			style={{
				width: `${size / 16}rem`,
				height: `${size / 16}rem`,
				padding: `${SIZE_TO_PADDING[size]}rem`,
				...externalStyle,
			}}
			className={`
				${absolute ? 'absolute' : 'relative'}
				self-center
				shrink-0
				group
				cursor-pointer
				disabled:cursor-not-allowed
				flex items-center justify-center

				rounded-full

				bg-neutrals-neutral-800/[0.44]

				outline outline-main
				outline-stroke-soft-200
				hover:outline-stroke-sub-300
				focus:outline-theme-yellow-primary-light

				transition-[outline-color] duration-300 ease-[ease]

				${className}
			`}
		>
			<IconWrapper
				size={WRAPPER_SIZE_TO_ICON_SIZE[size] * rem}
				className="relative z-10"
			>
				{children}
			</IconWrapper>
		</button>
	);
}

export default PlayerButton;
